import script from "./OrdersAndRevenueChart.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersAndRevenueChart.vue?vue&type=script&setup=true&lang=js"

import "./OrdersAndRevenueChart.vue?vue&type=style&index=0&id=0435dc66&scoped=true&lang=css"
import "./OrdersAndRevenueChart.vue?vue&type=style&index=1&id=0435dc66&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0435dc66"]])

export default __exports__